import {RefObject, useContext, useEffect, useRef, useState} from 'react';

//context 
import { ActivityFeedContext } from '@/context/ActivityFeedContext';

//clickaway close
import { useClickAwayCloseInModal } from  '@/components/hooks/utility/useClickAwayCloseInModal';

//component
import PopOutActivityFeedScreen from  '@/components/elements/activityFeed/popOutScreens/PopOutActivityFeedScreen';
import PopOutFilterScreen from  '@/components/elements/activityFeed/popOutScreens/PopOutFilterScreen';
import SimpleBar from 'simplebar-react';
import NavButton from  '@/components/elements/global/buttons/NavButton';
import { IconLibrary } from 'thrive-components';

//styling
import "../../../css/activityFeed/activity-feed-popout.scss";
import {AnimatePresence, motion} from "framer-motion";



const ActivityFeedPopOut = () => {
    const {setIsPopOut, onPopOutClick} = useContext(ActivityFeedContext);
    const [showActivityFeed, setShowActivityFeed] = useState<boolean>(false);
    const [showFilterView, setShowFilterView] = useState<boolean>(false);
    const popoutRef = useRef<HTMLDivElement>(null);
    
    useClickAwayCloseInModal(showActivityFeed, popoutRef as  RefObject<HTMLDivElement | null>, () =>{setShowActivityFeed(false)});

    useEffect(() => {
        if (showActivityFeed) {
            onPopOutClick();
        } else {
            setIsPopOut(false);
        }
    }, [showActivityFeed])

    return (
        <>
        <NavButton ariaLabel={'Show Activity Feed'} onButtonClick={()=> setShowActivityFeed(!showActivityFeed)} iconName={IconLibrary.ACTIVITY} tooltipText={"Activity Feed"} />

        {showActivityFeed && (
            <>
            <div className="modal-backdrop"></div>
                <div className="activity-feed-popout" ref={popoutRef}>
                    <SimpleBar>
                        <AnimatePresence mode="wait">
                            {showFilterView ? (
                                <motion.div
                                    key="filter"
                                    className="transition-wrapper"
                                    initial={{ x: 40, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    exit={{ x: 40, opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <PopOutFilterScreen onBackButtonClick={() => setShowFilterView(false)} />
                                </motion.div>
                            ) : (
                                <motion.div
                                    key="activity"
                                    className="transition-wrapper"
                                    initial={{ x: -40, opacity: 0 }}
                                    animate={{ x: 0, opacity: 1 }}
                                    exit={{ x: -40, opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <PopOutActivityFeedScreen onClosePopOut={() => setShowActivityFeed(!showActivityFeed)} onShowFilterViewClick={() => setShowFilterView(true)} />
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </SimpleBar>
                </div>
            </>)
        }
        </>
    )
};

export default ActivityFeedPopOut;
